
export default function ComparisonTable() {
  const comparisons = [
    {
      category: 'Vehicle Selection',
      rockhound: 'Any vehicle from any dealership, auction, or private seller nationwide',
      carvana: 'Limited to their 40k+ inventory only',
      dealer: "Limited to what's on their lot"
    },
    {
      category: 'Sourcing Options',
      rockhound: 'Buy online OR use broker to find anything',
      carvana: 'Online only, no broker service',
      dealer: 'In-person only, high pressure'
    },
    {
      category: 'Pricing Transparency',
      rockhound: 'Flat $995 broker fee, no hidden costs',
      carvana: 'Transparent pricing, but limited selection',
      dealer: 'Hidden fees, markups, add-ons'
    },
    {
      category: 'Delivery',
      rockhound: 'Often included in financing or purchase price',
      carvana: 'Delivery available, fees vary',
      dealer: 'Usually not offered'
    },
    {
      category: 'Financing Options',
      rockhound: 'Multiple lenders, all credit types',
      carvana: 'In-house financing only',
      dealer: 'Limited lenders, high rates'
    },
    {
      category: 'Return Policy',
      rockhound: 'No return policy — we do thorough inspections upfront so you know exactly what you\'re buying',
      carvana: '7-day return policy',
      dealer: 'As-is, no returns'
    },
    {
      category: 'Personal Service',
      rockhound: 'Expert broker advocacy available',
      carvana: 'Automated, minimal human contact',
      dealer: 'High-pressure sales tactics'
    },
    {
      category: 'Nationwide Access',
      rockhound: 'All 50 states, any vehicle',
      carvana: 'Limited to their inventory locations',
      dealer: 'Local lot only'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Rockhound vs. Carvana vs. Traditional Dealers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how we stack up against the competition across 8 key categories.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-2xl overflow-hidden shadow-lg" role="table" aria-label="Rockhound vs Carvana vs Traditional Dealers comparison">
            <thead>
              <tr className="bg-gradient-to-r from-teal-600 to-orange-600 text-white">
                <th scope="col" className="p-6 text-left font-bold text-lg">Category</th>
                <th scope="col" className="p-6 text-left font-bold text-lg">
                  <div className="flex items-center gap-2">
                    <i className="ri-trophy-line text-2xl" aria-hidden="true"></i>
                    Rockhound
                  </div>
                </th>
                <th scope="col" className="p-6 text-left font-bold text-lg">Carvana</th>
                <th scope="col" className="p-6 text-left font-bold text-lg">Traditional Dealer</th>
              </tr>
            </thead>
            <tbody>
              {comparisons.map((row, index) => (
                <tr
                  key={index}
                  className={`border-b border-gray-200 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
                >
                  <th scope="row" className="p-6 font-bold text-gray-900 text-left">{row.category}</th>
                  <td className="p-6 text-[#374151] bg-teal-50 border-l-4 border-teal-600">
                    <div className="flex items-start gap-2">
                      <i className="ri-check-line text-xl text-teal-600 mt-1 flex-shrink-0" aria-hidden="true"></i>
                      <span>{row.rockhound}</span>
                    </div>
                  </td>
                  <td className="p-6 text-[#374151]">{row.carvana}</td>
                  <td className="p-6 text-[#374151]">{row.dealer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-12 bg-gradient-to-br from-teal-50 to-orange-50 p-8 rounded-2xl border border-gray-200">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">The Rockhound Advantage</h3>
            <p className="text-lg text-[#374151] mb-6">
              We combine the convenience of online buying with the expertise of a personal broker —
              giving you more options, better service, and complete transparency than anyone else.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/inventory"
                className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition whitespace-nowrap inline-flex items-center justify-center gap-2 cursor-pointer"
              >
                <i className="ri-shopping-cart-line" aria-hidden="true"></i>
                Shop Online
              </a>
              <a
                href="/broker-services"
                className="bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-700 transition whitespace-nowrap inline-flex items-center justify-center gap-2 cursor-pointer"
              >
                <i className="ri-user-star-line" aria-hidden="true"></i>
                Use a Broker
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
